<template>
  <div>
    <app-header title="Stickers">
      <b-button v-router-link="{ name:'sticker-editor', params: { id:'new' }}" variant="primary">
        <i class="fa fa-plus-circle" /> New Sticker
      </b-button>
    </app-header>
    <loading-spinner v-if="!stickers" />
    <b-container v-else>
      <b-row>
        <b-col>
          <search-input v-model="query" />
        </b-col>
        <b-col class="text-right">
          {{ total }} Stickers
        </b-col>
      </b-row>
      <b-card-group columns>
        <b-card no-body
          v-for="sticker in displayStickers"
          :key="sticker.id"
          v-router-link="{name:'sticker-detail',params:sticker}"
        >
          <img :src="'https://cdn.gokaizen.com/' + sticker.src" alt="" style="max-width:100%;">
          <b-card-body>
            <h3>{{ sticker.name }}</h3>
            <p>{{ sticker.category_name }}</p>
          </b-card-body>
        </b-card>
      </b-card-group>
      <infinite-scrolling @infiniteHandler="infiniteHandler" />
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import $search from '@/services/search';
import AppHeader from '@/components/AppHeader';
import SearchInput from '@/components/SearchInput';
import LoadingSpinner from '@/components/LoadingSpinner';
import InfiniteScrolling from '@/components/InfiniteScrolling';

export default {
  components: {
    AppHeader,
    SearchInput,
    LoadingSpinner,
    InfiniteScrolling,
  },

  data() {
    return {
      query: '',
      stickers: null,
      page: 0,
      perPage: 7,
    };
  },

  computed: {
    displayStickers() {
      return $search(this.stickers, this.query, ['name', 'category_name']).slice(0, this.perPage * this.page);
    },

    total() {
      return (this.query) ? this.displayStickers.length : this.stickers.length;
    },
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      $api.get('/v1/internal/stickers').then((stickers) => {
        this.stickers = stickers;
      });
    },

    infiniteHandler($state) {
      if ((this.perPage * this.page) <= this.stickers.length) {
        this.page += 1;
        $state.loaded();
      } else {
        $state.complete();
      }
    },
  },
};
</script>
